import styled from 'styled-components'
import { Button } from '@gympass/yoga'
import tokens from '@gympass/yoga-tokens'

import LoadingButton from '@components/LoadingButton'

export const FrequentlyQuestionsWrapper = styled.section`
  padding-top: 20px;
  padding-bottom: 20px;
`

export const Title = styled.h2`
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 29px;
  margin: 36px 0 0;

  @media (min-width: ${tokens.breakpoints.md.width}px) {
    margin: 60px 0 0;
  }
`
export const CollapsiblePanelWrapper = styled.section`
  margin-top: 40px;
`
export const ContractButton = styled(LoadingButton)`
  margin-top: 24px;
  margin-bottom: 72px;

  @media (min-width: ${tokens.breakpoints.md.width}px) {
    margin-top: 64px;
    margin-bottom: 80px;
  }
`

export const RedoSimulation = styled(Button.Outline)`
  margin-top: 56px;

  @media (min-width: ${tokens.breakpoints.md.width}px) {
    margin-top: 64px;
    margin-bottom: 80px;
  }
`
